import * as React from 'react';
import {Button, Popover, Spin} from 'antd';
import {ErrorResponse, Invoice} from '../api/dtos/dtos';
import furoApi from '../api/FuroApi';
import {ErrorAlert} from '../common/ErrorAlert';
import locales from '../locales';
import {renderInvoiceType} from './invoice';
import InvoiceHistoryTable from './InvoiceHistoryTable';

interface Props {
  invoice: Invoice;
}

interface State {
  visible: boolean;
  loading: boolean;
  historyInvoices?: Invoice[];
  error?: ErrorResponse;
}

export default class InvoiceHistoryPopover extends React.Component<Props, State> {
  public state: State = {visible: false, loading: false};
  private requestId = 0;

  public componentWillUnmount() {
    this.requestId++;
  }

  public render() {
    const {invoice} = this.props;
    const {visible, loading, historyInvoices, error} = this.state;

    if (!invoice.historyInvoices?.length) {
      return renderInvoiceType(invoice.type);
    }

    return (
      <Popover
        trigger="click"
        placement="bottomLeft"
        visible={visible}
        onVisibleChange={this.onVisibleChange}
        title={`${locales.invoice_history} – ${invoice.externalNumber ?? invoice.internalNumber ?? '-'}`}
        content={
          <div style={{width: 600, maxWidth: 'calc(100vw - 48px)', maxHeight: '60vh', overflow: 'auto'}}>
            {loading ? <Spin/> : error ? <ErrorAlert error={error}/> :
              <InvoiceHistoryTable invoices={historyInvoices}/>}
          </div>
        }
      >
        <Button type="link" size="small" title={locales.invoice_history} aria-expanded={visible}>
          {renderInvoiceType(invoice.type)}
        </Button>
      </Popover>
    );
  }

  private onVisibleChange = (visible: boolean) => {
    const requestId = ++this.requestId;
    this.setState({visible, loading: visible, error: undefined, historyInvoices: undefined});
    if (!visible) {
      return;
    }

    furoApi.invoicing.getInvoice(this.props.invoice.id)
      .then(invoice => {
        if (requestId === this.requestId) {
          this.setState({
            historyInvoices: [invoice, ...(invoice.historyInvoices ?? []).filter(item => item.id !== invoice.id)]
              .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()),
            loading: false,
            visible: !!invoice.historyInvoices?.length,
          });
        }
      })
      .catch((error: ErrorResponse) => {
        if (requestId === this.requestId) {
          this.setState({error, loading: false});
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/invoicing/InvoiceHistoryPopover.tsx